export enum EnumEntregaFlPgmnt {
    NAO = 0,
    SIM = 1,
    CENTRALIZADA = 2,
}